import { VALIDATIONS_SEVERITY } from "src/components/collections/consts";
import { KNOWLEDGE_SOURCES_VALIDATION_PREFIX } from "src/components/collections/knowledge-sources/explore/ExploreTab.consts";

export const createCollectionSelector = state => state.createCollection;
export const editCollectionSelector = state => state.editCollection;
export const deleteCollectionSelector = state => state.deleteCollection;
export const isDialogLoadingSelector = state => state.isDialogLoading;
export const dialogErrorSelector = state => state.dialogError;
export const setDialogErrorSelector = state => state.setDialogError;
export const setDialogLoadingSelector = state => state.setDialogLoading;
export const settingsPhoneNumbersChangedSelector = state => state.settingsPhoneNumbersChanged;
export const setSettingsPhoneNumbersChangedSelector = state => state.setSettingsPhoneNumbersChanged;
export const collectionsSelector = state => state.collections;
export const isPageLoadingSelector = state => state.isPageLoading;
export const hasPageErrorSelector = state => state.hasPageError;
export const resetCollectionsDataSelector = state => state.resetCollectionsData;
export const collectionConfigSelector = state => state.currentCollectionConfig;
export const originalCollectionConfigSelector = state => state.originalCollectionConfig;
export const collectionsLanguagesSelector = state => state.languages?.current?.list;
export const defaultCollectionsLanguagesSelector = state => state.languages?.current?.default;
export const isAgentSingleLanguageSelector = state => state.languages?.current?.list?.length === 1;
export const currentSelectedLanguageSelector = state => state.currentSelectedLanguage;
export const setCurrentSelectedLanguageSelector = state => state.setCurrentSelectedLanguage;
export const selectedCollectionSelector = state => state.selectedCollection;
export const setSelectedCollectionConfigSelector = state => state.setSelectedCollectionConfig;
export const setSelectedCollectionSelector = state => state.setSelectedCollection;
export const setIsUpdatingCollectionSelector = state => state.setIsUpdatingCollection;
export const isUpdatingCollectionSelector = state => state.isUpdatingCollection;
export const updateCollectionSelector = state => state.updateCollection;
export const updateChannelSettingsSelector = state => state.updateChannelSettings;
export const updateLanguagesSelector = state => state.updateLanguages;
export const getChannelSettingsSelector = state => state.getChannelSettings;
export const collectionConfigChangedSelector = state => state.collectionConfigChanged;
export const setCollectionConfigChangedSelector = state => state.setCollectionConfigChanged;
export const settingsConfigChangedSelector = state => state.settingsConfigChanged;
export const setSettingsConfigChangedSelector = state => state.setSettingsConfigChanged;
export const configurationSettingsChangedSelector = state => state.configurationSettingsChanged;
export const setConfigurationSettingsChangedSelector = state => state.setConfigurationSettingsChanged;
export const setCurrentChannelSettingsSelector = state => state.setCurrentChannelSettings;
export const currentChannelSettingsSelector = state => state.currentChannelSettings;
export const setInitialChannelSettingsSelector = state => state.setInitialChannelSettings;
export const initialChannelSettingsSelector = state => state.initialChannelSettings;
export const currentChannelDraftSettingsSelector = state => state.draftChannelSettings;
export const isSavingChangesSelector = state => state.isSavingChanges;
export const setCollectionNameSelector = state => state.setCollectionName;
export const collectionNameSelector = state => state.collectionName;
export const getCollectionOptionsSelector = state => state.getCollectionOptions;
export const failedToUpdateDraftSelector = state => state.failedToUpdateDraft;
export const hasAddedFilterSelector = state => state.hasAddedFilter;
export const setHasAddedFilterSelector = state => state.setHasAddedFilter;
export const setFailedToUpdateDraftSelector = state =>
  state.setFailedToUpdateDraft;

export const isFetchingValidationResultsSelector = state => state.fetchingValidationResults;
export const hasFetchedInitialValidationResultsSelector = state => state.hasFetchedInitialValidationResults;
export const validationResultsSelector = state => state.validationResults.current;
export const knowledgeValidationsSelector = state => state.knowledgeValidations;

const hasError = (results) => results.some(({ error_severity_level }) => error_severity_level === VALIDATIONS_SEVERITY.ERROR);

const knowledgeEntryHasError = ({ rows, type }) => hasError(type) || Object.values(rows).some(hasError);

export const hasKnowledgeValidationErrorsSelector = state =>
  Object.values(state.knowledgeValidations || {}).some(knowledgeEntryHasError);

// Mechanism-1 validation results scoped to knowledge-source rows (paths flattened as
// "knowledge-sources/{specKey}/{ksInstanceId}/{rowPk}/{column}") - these never match the
// knowledge nav item's route key ("knowledge-studio"), so the badge checks them by prefix.
export const hasKnowledgeSourceValidationErrorsSelector = state =>
  Object.entries(state.validationResults.current || {}).some(
    ([path, results]) => path.startsWith(`${KNOWLEDGE_SOURCES_VALIDATION_PREFIX}/`) && hasError(results)
  );

export const knowledgeSchemaTypeHasErrors = (state, schemaType) => {
  const entry = state.knowledgeValidations?.[schemaType];
  return Boolean(entry && knowledgeEntryHasError(entry));
};

export const hasValidationErrors = state =>
  Object.values(state.validationResults.current || {}).some(hasError) ||
  hasKnowledgeValidationErrorsSelector(state);

export const lastCollectionCreatedKeySelector = state => state.lastCollectionCreatedKey;
export const setLastCollectionCreatedKeySelector = state => state.setLastCollectionCreatedKey;
export const collectionBreadCrumbsSelector = state => state.collectionBreadCrumbs;

export const collectionBreadCrumbsLastItemSelector = state => state.collectionBreadCrumbs[state.collectionBreadCrumbs.length - 1];
export const addToCollectionBreadCrumbsSelector = state => state.addToCollectionBreadCrumbs;
export const removeLastItemFromCollectionBreadCrumbsSelector = state => state.removeLastItemFromCollectionBreadCrumbs;

export const clearCollectionBreadCrumbsSelector = state => state.clearCollectionBreadCrumbs;

export const setIgnoreUrlChangeSelector = state => state.setIgnoreUrlChange;
export const ignoreUrlChangeSelector = state => state.ignoreUrlChange;
export const getConnectivityTestResultsSelector = state => state.getConnectivityTestResults;
export const utteranceGroupingSelector = state => state.utteranceGrouping;
export const generalGroupingSelector = state => state.generalGrouping;

